import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Shelf, Grid } from "capitalrx-components-2.0/lib/layout";
import styled from "styled-components";

const FooterContainer = styled.div`
  height: 60px;
  margin-top: 80px;
  background-color: white;
  padding-top: 20px;
`;

export const Footer: FC = () => {
  const { t: translate } = useTranslation();
  return (
    <FooterContainer>
      <Grid>
        <Grid.Span columns={1} />
        <Grid.Span columns={10}>
          <Shelf>
            <div>© {new Date().getFullYear()} Capital Rx</div>
            <Shelf.Spacer />
            <a href="https://www.cap-rx.com/legal#legal-notice-privacy-policy">{translate("FOOTER.legalNotices")}</a>
          </Shelf>
        </Grid.Span>
        <Grid.Span columns={1} />
      </Grid>
    </FooterContainer>
  );
};
